import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { IdentityService } from '../api/services';
import { catchError, map, of } from 'rxjs';
import { GrantsService } from '../services/grants.service';

export const grantResolver: ResolveFn<boolean> = (route, state) => {
  const api = inject(IdentityService);
  const grantsService = inject(GrantsService);

  return api.identityControllerGetGrants().pipe(
    map(response => {
      if (response.result) {
        grantsService.grantList = response.data.grants;
      }
      return response.result;
    }),
    catchError(() => of(false))
  );
};
